module.exports = __webpack_public_path__ + "img/A.b3abb55d.png";